import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { USER_MANAGEMENT_QUERY_KEY } from "./api/customers/useUserManagementRoles";

const useRefetchUserManagementQueries = () => {
  const queryClient = useQueryClient();

  return useCallback(
    () => queryClient.refetchQueries({ queryKey: [USER_MANAGEMENT_QUERY_KEY] }),
    [queryClient]
  );
};

export default useRefetchUserManagementQueries;
